module.exports = __webpack_public_path__ + "static/img/icn_mail@3x.8d70c8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icn_mail@3x.png
// module id = KMEr
// module chunks = 10